export interface Module {
  id?: string;
  name: string;
  abbreviation?: string;
  description: string;
  status?: number;
  iconUrl?: string;
  locationUrl: string;
  favIconUrl: string;
  landingPageUrl?: string;
}
